<template>
  <section class="mothly-view-calc monthly-split-view table-monthly-view">
    <main-form-vue
      :popup="popup"
      :edit-level="editLevel"
      :first-click="firstClick"
      :set-edit-level="setEditLevel"
      :set-first-click="setFirstClick"
      :add-option-selected="addOptionSelected"
    />
  </section>
</template>

<script>
import MainFormVue from "./MainForm.vue";

export default {
  components: {
    MainFormVue
  },
  props: {
    editLevel: {
      type: Number,
      default: 0
    },
    firstClick: {
      type: Boolean,
      default: false
    },
    setEditLevel: {
      type: Function,
      default: () => {}
    },
    setFirstClick: {
      type: Function,
      default: () => {}
    },
    addOptionSelected: {
      type: Function,
      default: () => {}
    }, // When add client/person/event group is selected
    popup: Function
  }
};
</script>

<style scoped>
section {
  margin-top: 98px;
  margin-bottom: 90px;
}
</style>
